import React, { useState } from "react";

const faqs = [
  {
    question: "Do I need an NIE number to buy property in Spain?",
    answer:
      "Yes. The NIE (Número de Identidad de Extranjero) is required for purchasing property, opening a bank account, and completing various legal procedures in Spain.",
  },
  {
    question: "Can Benzies assist with mortgage applications?",
    answer:
      "Absolutely. We work with trusted financial partners and can guide you through the mortgage process to help secure the most suitable financing options.",
  },
  {
    question: "Do you provide property management services?",
    answer:
      "Yes. We offer comprehensive property maintenance and management solutions for homeowners and investors.",
  },
  {
    question: "Can you help with relocation and schools?",
    answer:
      "Yes. We assist families with relocation services, school selection, healthcare registration, and settling comfortably in Spain.",
  },
  {
    question: "Do you offer services for holiday homeowners?",
    answer:
      "Yes. Our concierge services are designed to help holiday homeowners with property maintenance, key holding, cleaning, and lifestyle support.",
  },
];

const FAQ = () => {
  const [active, setActive] = useState(null);

  const toggleFAQ = (index) => {
    setActive(active === index ? null : index);
  };

  return (
    <section className="max-w-[1200px] mx-auto px-6 py-28">
      {/* Heading */}
      <div className="text-center max-w-[800px] mx-auto mb-20">
        <span
          className="uppercase tracking-[3px] text-[#B68A35] text-[14px] font-medium"
          style={{ fontFamily: "Poppins" }}
        >
          Frequently Asked Questions
        </span>

        <h2
          className="text-[55px] leading-tight text-[#0F172A] mt-4"
          style={{ fontFamily: "Pochaevsk" }}
        >
          Everything You Need To Know
        </h2>

        <p
          className="text-gray-500 text-[17px] leading-8 mt-6"
          style={{ fontFamily: "Poppins" }}
        >
          Find answers to the most common questions about our concierge and
          personal services in Spain.
        </p>
      </div>

      {/* Accordion */}
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-[#F9F8F4] rounded-[25px] overflow-hidden shadow-sm border border-[#ECE7DD]"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full flex justify-between items-center px-8 py-7 text-left"
            >
              <h3
                className="text-[24px] text-[#0F172A]"
                style={{ fontFamily: "Pochaevsk" }}
              >
                {faq.question}
              </h3>

              <span className="text-[#B68A35] text-[28px]">
                {active === index ? "−" : "+"}
              </span>
            </button>

            <div
              className={`transition-all duration-500 overflow-hidden ${
                active === index ? "max-h-[300px]" : "max-h-0"
              }`}
            >
              <div className="px-8 pb-8">
                <p
                  className="text-gray-500 leading-8 text-[16px]"
                  style={{ fontFamily: "Poppins" }}
                >
                  {faq.answer}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;